import React from 'react'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" fill="none" viewBox="0 0 12 13">
      <path
        fill="#202020"
        fillOpacity="0.5"
        d="M8.164 7.33333H3.836L2.76933 10H1.33333L5.33333 0H6.66667L10.6667 10H9.23067L8.164 7.33333ZM7.63067 6L6 1.92333L4.36933 6H7.63067V6ZM0 11.3333H12V12.6667H0V11.3333Z"
      ></path>
    </svg>
  )
}

export default Icon

